import AnchorLinks from './anchor-links';
import _ from 'lodash';

/**
 * Tabs UI element logic.
 */
class Tabs {

  /**
   * Tab pair objects. Each object has a desktop tab button and a mobile tab button.
   * @type {Array<{desktop: HTMLElement, mobile: HTMLElement, content: HTMLElement}>}
   */
  #tabPairs = [];

  /**
   * @constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor(element) {
    this._element = element;

    this.#createTabPairs();

    //this._element.querySelectorAll('.tabs__tab:not(.tabs_scroller)').forEach(element => {

    this._element.querySelectorAll(
      ':scope > .tabs__controls-container > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__controls-container > .tabs__tab-wrapper > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__headings > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__headings > .tabs__controls-container > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__headings > .tabs__controls-container > .tabs__tab-wrapper > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__contents > .tabs__tab:not(.tabs_scroller)'
    ).forEach(element => {
      element.addEventListener('click', this._onTabChanges.bind(this));
      element.addEventListener('customClick', this._onTabChanges.bind(this));
    });

    const onReSizeDebouce = _.debounce(this.onResize.bind(this), 100);
    window.addEventListener('resize', onReSizeDebouce);

    this._element.tabs = this;
  }

  onResize() {
    const contentsClosed = !this._element.querySelector('.tabs__tab:not(.tabs_scroller).tabs__tab--open');

    // Open the first tab if all tabs are closed when resizing to desktop view.
    if(window.innerWidth >= 1024 && this.#tabPairs.length > 0 && contentsClosed) {// tablet landscape
      this.openTab(this.#tabPairs[0].desktop.getAttribute('aria-controls'), true);
      this.#tabPairs[0].desktop.focus();
    }
  }

  /**
   * Create a easliy accessible array object's that hold desktop, mobile and content tab elements.
   */
  #createTabPairs() {
    this.#tabPairs = [];


    //const desktopTabButtons = this._element.querySelectorAll('.tabs__headings .tabs__tab:not(.tabs_scroller), .tabs__controls-container .tabs__tab:not(.tabs_scroller)')
    //const mobileTabButtons = Array.from( this._element.querySelectorAll('.tabs__contents .tabs__tab'));

    // Desktop tabs
    const desktopTabButtons = this._element.querySelectorAll(
      ':scope > .tabs__headings > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__controls-container > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__controls-container > .tabs__tab-wrapper > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__headings > .tabs__controls-container > .tabs__tab:not(.tabs_scroller), ' +
      ':scope > .tabs__headings > .tabs__controls-container > .tabs__tab-wrapper > .tabs__tab:not(.tabs_scroller)'
    );

    const mobileTabButtons = Array.from(
      this._element.querySelectorAll(':scope > .tabs__contents > .tabs__tab')
    );

    desktopTabButtons.forEach(tab => {

      mobileTabButtons
      const mobileTab = mobileTabButtons.find( mobileTab => mobileTab.getAttribute('aria-controls') === tab.getAttribute('aria-controls'))
      const pair = {
        desktop: tab,
        mobile: mobileTab,
        content: document.getElementById(tab.getAttribute('aria-controls'))
      };
      this.#tabPairs.push(pair);
    });
  }

  /**
   * Opens a target tab by adding right CSS classes to headings and content element.
   * @param {string} elementId content tab element id
   * @param {boolean} show show or hide the tab
   */
  openTab(elementId, show) {
    const pair = this.#tabPairs.find(pair => pair.desktop.getAttribute('aria-controls') === elementId);

    if (pair) {
      pair.desktop.classList.toggle('tabs__tab--open', show);
      pair.mobile?.classList?.toggle('tabs__tab--open', show);
      pair.content.setAttribute('aria-expanded', show);
      pair.content.classList.toggle('tab--open', show);
    }

    // Close other tabs.
    this.#tabPairs.filter(pair => pair.desktop.getAttribute('aria-controls') !== elementId).forEach(pair => {
      pair.desktop.classList.remove('tabs__tab--open', false);
      pair.mobile?.classList?.remove('tabs__tab--open', false);
      pair.content.setAttribute('aria-expanded', 'false', false);
      pair.content.classList.remove('tab--open', false);
    });
  }

  /**
   * Called when a tab changes
   * @param {Event} event mouse click event
   */
  _onTabChanges(event) {
    // if (event.isTrusted) {
    event.preventDefault();

    const targetElement = event.target;
    const isDisabled = targetElement.classList.contains('tabs__tab--disabled');

    if (!isDisabled) {
      if (this._element.classList.contains('tabs_scroll_to_view') &&
            !(this._element.classList.contains('tabs--mobile-accordion') && window.innerWidth <= 1024) ) {
        AnchorLinks.offsetScroll(this._element, targetElement);
      }

      const tabId = targetElement.getAttribute('aria-controls');
      let show = !this.isTabOpen(tabId);

      // Desktop view tab can't be closed by clicking on it.
      if( window.innerWidth >= 1024 ) {// tablet landscape
        show = true;
      }

      this.openTab(tabId, show);
    }
    // }
  }

  /**
   * Return is the tab is open or not.
   * @param {string} elementId tab content element id
   * @returns {boolean} true if is open, false otherwise
   */
  isTabOpen(elementId) {
    const pair = this.#tabPairs.find(pair => pair.desktop.getAttribute('aria-controls') === elementId);
    return pair && pair.desktop.classList.contains('tabs__tab--open');
  }

  static init() {
    document.querySelectorAll('.tabs').forEach(tabContainer => {
      new Tabs(tabContainer);
    });
  }
}

export default Tabs;
